<main class="s-siteContainer">

  <nav class="c-path" aria-label="breadcrumb" *ngIf="newsPage">
    <div class="l-container">
      <ul class="c-path__list">
        <li><a [routerLink]="['/']" translate>Naslovnica</a></li>
        <li><a *ngIf="newsPage.category.urlSlug"
               [routerLink]="['/', newsPage.category.urlSlug]">{{newsPage.category.name}}</a>
          <a *ngIf="!newsPage.category.urlSlug">{{newsPage.category.name}}</a></li>
        <li class="is-active" aria-current="page"><a>{{newsPage.title}}</a></li>
      </ul>
    </div>
  </nav>

  <div class="c-media__placeholder is-2:1 is-loading" *ngIf="!newsPage"></div>

  <!-- Article header -->
  <div class="c-articleHeader" *ngIf="newsPage">
    <div class="c-articleHeader__image">
      <img [src]="newsPage.mainImage | file:'image':'cms':1280" [alt]="newsPage.title">
    </div>
    <div class="c-articleHeader__container">
      <div class="l-container--md">
        <div class="c-articleHeader__tags">
          <div class="e-tag">
            <i class="icon icon-clock" aria-hidden="true"></i>
            <span>{{newsPage.publishedAt | date:'dd.MM.yyyy.'}}</span>
          </div>
          <div class="e-tag e-tag--author">
            {{'Autor:' | translate}} <strong>{{newsPage.author}}</strong>
          </div>
        </div>
        <h1 class="c-articleHeader__title">
          {{newsPage.title}}
        </h1>
      </div>
    </div>
  </div>


  <!-- Article container -->
  <section class="s-section" *ngIf="newsPage">
    <div class="l-container--sm">
      <div class="c-article">
        <div class="c-article__share">
          <div class="c-share">
            <a class="fb-share-button c-share__btn" target="_blank"
               [href]="'https://www.facebook.com/sharer/sharer.php?sdk=fb-sdk&u=' + encodeSiteUrl(SITE_URL + newsPage.category.urlSlug + '/' + newsPage.urlSlug) + '&display=popup&ref=plugin&src=share_button'"
               onclick="return !window.open(this.href, 'Facebook', 'width=640,height=580')">
              <i class="icon icon-facebook"></i>
            </a>
            <a class="twitter-share-button c-share__btn" target="_blank"
              [href]="'https://twitter.com/intent/tweet?text=' + newsPage.description + '&url=' + encodeSiteUrl(SITE_URL + newsPage.category.urlSlug + '/' + newsPage.urlSlug)"
               onclick="return !window.open(this.href, 'Twitter', 'width=640,height=580')">
              <i class="icon icon-twitter"></i>
            </a>
          </div>
        </div>

        <!-- Article intro -->
        <div class="c-article__intro" *ngIf="newsPage.description">
          {{newsPage.description}}
        </div>

        <!-- Article content -->
        <div class="c-article__content">
          <div class="l-grid">
            <div class="l-col sm:12 lg:{{getSize(component['columns'])}}" *ngFor="let component of newsPage.components"
                 [ngSwitch]="component.type">
              <app-paragraph *ngSwitchCase="'PARAGRAPH'" [component]="component"></app-paragraph>
              <app-image *ngSwitchCase="'IMAGE'" [component]="component"></app-image>
              <app-video *ngSwitchCase="'YOUTUBE_VIDEO'" [component]="component"></app-video>
              <app-link-button *ngSwitchCase="'LINK'" [component]="component"></app-link-button>
              <app-file-download *ngSwitchCase="'FILE'" [component]="component"></app-file-download>
              <app-quote *ngSwitchCase="'QUOTE'" [component]="component"></app-quote>
            </div>
          </div>
        </div>
      </div>
      <div class="s-block" style="padding-bottom: 0">
        <div class="l-container">
          <nav class="c-pgn" role="navigation" aria-label="Pagination Navigation">
            <a [routerLink]="['../', newsPage.previousPage.urlSlug]" *ngIf="newsPage.previousPage" class="c-pgn__prev"
               aria-label="Prethodni">
              <div class="e-icon">
                <i class="icon-angle-left" aria-hidden="true"></i>
              </div>
              <span translate>Prethodni</span>
            </a>
            <a [routerLink]="['../', newsPage.nextPage.urlSlug]" *ngIf="newsPage.nextPage" class="c-pgn__next"
               aria-label="Sljedeći">
              <span translate>Sljedeći</span>
              <div class="e-icon">
                <i class="icon-angle-right" aria-hidden="true"></i>
              </div>
            </a>
            <a [routerLink]="['../']" *ngIf="newsPage.category.urlSlug" class="c-pgn__back">
              <span>{{newsPage.category.name}}</span>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </section>

  <!-- Related news -->
  <section class="s-section s-relatedNews has-bg-2" [hidden]="!newsPage">
    <div class="l-container">
      <div class="s-section__header">
        <h2 class="s-section__title" translate>
          Povezani članci
        </h2>
      </div>
      <div class="s-section__main">
        <div app-slider class="s-section__main" [loading]="!newsPage"
             [tabs]="[{items: newsPage?.connectedPages}]"></div>
      </div>
    </div>
  </section>

  <app-subscription-form *ngIf="!user"></app-subscription-form>

</main>
